package space.stanton.pages.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initAbout_mePage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("pages/about_me.md", FrontMatterElement.Builder { addScalar("title", "About me"); }))
}

@Page("/pages/about-me")
@Composable
fun About_mePage() {
    space.stanton.components.layouts.AboutMe {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Hi. I'm Stanton")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("My full name is actually Steven Stanton, but everyone just calls me Stanton.")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("I am both a professional and a hobbyist developer. My main focus has been Android apps. I’m based in Manchester, UK.")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("This is a blog about code stuff I'm learning and code stuff I would like to share. I hope you find some of it useful.")
        }
    }
}
